<template>
  <div
    id="app"
    :style="{ marginTop: $globalData.TokenOK == 1 ? '2cm' : '0px' }"
  >
    <div class="gradient-background" v-show="$globalData.TokenOK == 1"></div>
    <!-- <Navbarform v-show="false" /> -->
    <div :class="$globalData.TokenOK == 1 ? 'container-fluid' : 'fluid'">
      <div
        :class="[
          $globalData.TokenOK == 1 ? 'fixed-top text-left' : 'text-center',
          'bg-white',
          'border-bottom',
        ]"
        v-show="$globalData.TokenOK == 1"
      >
        <!-- <img src="./assets/images/logo_ponpes.jpg" width="100%" height="75px" bg-white /> -->
        <img
          src="./assets/images/LogoBaiturrahmanMobile.png"
          widthx="390px"
          height="40px"
          class="ml-4 mt-1"
        />

        <span class="mt-4 ml-2 font-weight-bold">Baiturrahman Mobile</span>
        <!-- <span class="ml-2 text-muted small">{{ $globalData.UserId }}</span> -->
        <sup class="ml-0">
          <b-badge style="font-size: 8px" variant="info"
            >1.0
            <!-- {{ $globalData.versiaplikasi }} -->
          </b-badge></sup
        >
        <div style="position: absolute; margin-top: -50px" v-if="false">
          <div class="row">
            <!-- <div class="col">
            </div> -->
            <div class="col pl-0">
              <div
                class="social-media-links"
                style="font-size: 10px; margin-top: 35px; margin-left: 70px"
              >
                <a
                  href="https://www.youtube.com/@pesantrenbaiturrahman"
                  target="_blank"
                  aria-label="YouTube"
                >
                  <i class="bi bi-youtube"></i>
                  <!-- <span>YouTube</span> -->
                </a>
                <a
                  href="https://baiturrahman.com/"
                  target="_blank"
                  aria-label="Website"
                >
                  <i class="bi bi-globe"></i>
                  <!-- <span>Website</span> -->
                </a>
                <a
                  href="https://www.instagram.com/ponpesbaiturrahman/"
                  target="_blank"
                  aria-label="Instagram"
                >
                  <i class="bi bi-instagram"></i>
                  <!-- <span>Instagram</span> -->
                </a>
                <a
                  href="https://www.facebook.com/officialbaiturrahman"
                  target="_blank"
                  aria-label="Facebook"
                >
                  <i class="bi bi-facebook"></i>
                  <!-- <span>Facebook</span> -->
                </a>
                <a
                  href="https://wa.link/scp19c"
                  target="_blank"
                  aria-label="WhatsApp"
                >
                  <i class="bi bi-whatsapp"></i>
                  <!-- <span>WhatsApp</span> -->
                </a>
                <a
                  href="https://www.tiktok.com/@ponpesbaiturrahman"
                  target="_blank"
                  aria-label="TikTok"
                >
                  <i class="bi bi-tiktok"></i>
                  <!-- <span>TikTok</span> -->
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mt-0 mr-1 float-right bg-white"
          v-show="$globalData.TokenOK == 1"
        >
          <br />
          <i class="bi bi-box-arrow-right small mr-2" @click="logout"></i><br />
        </div>

        <!-- <hr v-show="$globalData.TokenOK == 1" /> -->
      </div>
      <div :class="$globalData.TokenOK == 1 ? 'fluid' : 'fluid'">
        <!-- <div class="gradient-background"></div> -->
        <router-view />
      </div>
      <div
        class="menu-fixed-bottom col-md-6"
        v-show="$globalData.TokenOK == '1' && $globalData.LoginOK == '1'"
      >
        <!-- MENU {{ selectedMenu }} -->
        <div
          class="menu-item"
          v-for="(menu, index) in menus"
          :key="menu.name"
          :class="{ active: selectedMenu === index }"
          @click="selectMenus(index)"
        >
          <i :class="menu.icon" class="menu-icon"></i>
          <p>{{ menu.name }}</p>
        </div>
      </div>
    </div>
    <Footer v-show="$globalData.LoginOK == '2'" />
  </div>
</template>

<script>
import Footer from "./components/footer.vue";
export default {
  name: "App",
  components: {
    Footer,
  },
  data() {
    return {
      menus: [
        { name: "Home", icon: "bi bi-house" },
        { name: "Profile", icon: "bi bi-person-square" },
        { name: "Kalender", icon: "bi bi-calendar2-event" },
        { name: "PMB", icon: "bi bi-dribbble" },
        { name: "Ibadah", icon: "bi bi-bar-chart-steps" },
        { name: "Izin", icon: "bi bi-lock" },
      ],
      selectedMenu: 0,
    };
  },
  //      UserId: "",
  //   LoginOK: '',
  //   TokenOK: 0,
  mounted() {
    document.title = "Baiturrahman Mobile";

    this.$globalData.userId =
      localStorage.getItem("userid") === null
        ? ""
        : localStorage.getItem("userid");
    this.selectMenus(0);
  },
  methods: {
    logout() {
      this.$globalData.TokenOK = 0;
      this.$globalData.LoginOK = "";
      this.$router.push({ path: "/" });
    },
    selectMenus(index) {
      this.selectedMenu = index;
      this.$globalData.SelectedMenu = index;
      console.log("Menu", this.selectedMenu);
    },
  },
};
</script>

<style scoped>
.pmb-container {
  padding: 20px;
  padding-bottom: 70px;
  /* Memberi ruang untuk menu di bawah */
}

h2 {
  margin-bottom: 20px;
}

.content {
  min-height: 300px;
  /* Simulasi konten */
}

/* Menu fixed di bagian bawah */
.menu-fixed-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  /* Agar menu berjajar */
  align-items: center;
  border-top: 0px solid #ccc;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  padding: 5px 0;
  z-index: 1000;
  /* Pastikan menu di atas elemen lain */
}

.menu-item {
  flex: 1;
  text-align: center;
  padding: 1px;
  transition: background-color 0.3s ease;
}

.menu-icon {
  font-size: 24px;
  /* Ukuran icon */
  margin-bottom: 5px;
  color: #333;
}

.menu-item p {
  margin: 0;
  font-size: 12px;
  /* Ukuran teks menu */
}

/* Warna aktif saat menu dipilih */
.menu-item.active {
  background-color: #64686b;
  /* Warna biru saat aktif */
  color: white;
}

.menu-item.active .menu-icon {
  color: white;
}

.social-media-links {
  display: grid;
  grid-template-columns: repeat(6, 14px);
  gap: 5px;
  /* Jarak antar item */
  justify-items: center;
  align-items: center;
}

.social-media-container {
  text-align: center;
  margin-top: 5px;
}

/* Responsif untuk layar kecil */
@media (max-width: 600px) {
  .menu-item {
    font-size: 10px;
  }

  .menu-icon {
    font-size: 20px;
  }
}
</style>
